import { useDraggable } from "@dnd-kit/core";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/modules/lists/types/columns";

import { ScoringRuleCard, type ScoringRuleCardProps } from "./ScoringRuleCard";
import { ScoringRuleDragHandle } from "./ScoringRuleDragHandle";
import { StyledDraggableRuleCardWrapper } from "./styles";

type Props = ScoringRuleCardProps & {
    ruleId: string;
    sourcePriority: LeadPriorityScore;
    ruleIndex: number;
    isDraggable: boolean;
};

export const DraggableScoringRuleCard = ({ ruleId, sourcePriority, ruleIndex, isDraggable, ...cardProps }: Props) => {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
        id: ruleId,
        data: { sourcePriority, ruleIndex, ruleId },
        disabled: !isDraggable,
    });

    return (
        <StyledDraggableRuleCardWrapper
            ref={setNodeRef}
            $isDragging={isDragging}
            data-automation="scoring-rule-card.draggable-wrapper"
        >
            {isDraggable ? (
                <ScoringRuleDragHandle
                    {...listeners}
                    {...attributes}
                />
            ) : null}
            <ScoringRuleCard {...cardProps} />
        </StyledDraggableRuleCardWrapper>
    );
};
